import {BluechatNoteAttachment, BluechatNoteCreation} from './BluechatNoteCreation';

export class BluechatBulkNoteCreation {
  attachments: BluechatNoteAttachment[]
  requests: BluechatNoteCreation[]
}
